import { useEffect, useRef, useState } from "react";

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let scriptLoadingPromise = null;
function loadGoogleMaps() {
  if (window.google?.maps?.places) return Promise.resolve();
  if (scriptLoadingPromise) return scriptLoadingPromise;
  scriptLoadingPromise = new Promise((resolve, reject) => {
    if (!GOOGLE_KEY) {
      reject(new Error("Google Maps API key manquante"));
      return;
    }
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY}&libraries=places&language=fr&region=FR`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = (e) => reject(e);
    document.head.appendChild(s);
  });
  return scriptLoadingPromise;
}

/**
 * AddressAutocomplete - uses Google Places Autocomplete (legacy widget).
 * onSelect({ formatted_address, lat, lng })
 */
export default function AddressAutocomplete({
  value,
  onChange,
  onSelect,
  placeholder = "Adresse...",
  testId = "address-autocomplete",
  disabled = false,
}) {
  const inputRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [internal, setInternal] = useState(value || "");

  useEffect(() => {
    setInternal(value || "");
  }, [value]);

  useEffect(() => {
    let acInstance = null;
    let listener = null;
    loadGoogleMaps()
      .then(() => {
        if (!inputRef.current) return;
        acInstance = new window.google.maps.places.Autocomplete(inputRef.current, {
          types: ["address"],
          componentRestrictions: { country: ["fr"] },
          fields: ["formatted_address", "geometry", "name"],
        });
        listener = acInstance.addListener("place_changed", () => {
          const place = acInstance.getPlace();
          const fa = place.formatted_address || place.name || "";
          const lat = place.geometry?.location?.lat?.() ?? null;
          const lng = place.geometry?.location?.lng?.() ?? null;
          setInternal(fa);
          onChange?.(fa);
          onSelect?.({ formatted_address: fa, lat, lng });
        });
        setReady(true);
      })
      .catch((e) => {
        console.error("Google Maps load error", e);
      });
    return () => {
      if (listener && window.google?.maps?.event) {
        window.google.maps.event.removeListener(listener);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      ref={inputRef}
      data-testid={testId}
      value={internal}
      onChange={(e) => {
        setInternal(e.target.value);
        onChange?.(e.target.value);
      }}
      placeholder={ready ? placeholder : "Chargement…"}
      disabled={disabled}
      autoComplete="off"
      className="lc-input"
    />
  );
}
